import { Banner, Button, FlexBox, Text } from '@dixa/lib-shared-habla';

import styles from '../composeEmailModal.module.scss';
import type { FormValues } from '../composeEmailModal.types';

const linkTypeLabelMap = (
  parentConversation: number,
): Record<string, string> => ({
  email_forward: `Compose a transcript of conversation #${parentConversation}`,
  follow_up: `Follow-up on conversation #${parentConversation}`,
  side: `Compose a side conversation to #${parentConversation}`,
});

type Props = {
  linkType: FormValues['linkType'];
  parentConversation: number;
  linkedDataLoading: boolean;
  onCopyPaste: () => void;
};

export function ComposeEmailLinkedBanner({
  linkType,
  parentConversation,
  linkedDataLoading,
  onCopyPaste,
}: Props): JSX.Element {
  return (
    <Banner
      className={styles.banner}
      variant="info"
      icon={null}
      description={
        <FlexBox flexDirection="column" gap="200">
          <Text.Paragraph>
            {linkTypeLabelMap(parentConversation)[linkType ?? 'side']}
          </Text.Paragraph>
          {(!linkType || linkType === 'side') && (
            <Button
              type="button"
              variant="secondary"
              onClick={onCopyPaste}
              isLoading={linkedDataLoading}
              disabled={linkedDataLoading}
            >
              Copy & Paste from conversation #{parentConversation}
            </Button>
          )}
        </FlexBox>
      }
    />
  );
}
